<template>
  <div
      id="content"
  >

    <div
        v-if="!hasPOBRInit"
        class="tw-h-[calc(100vh-50px)] tw-mt-skip-header tw-flex tw-justify-center tw-items-center"
    >
      <ui-mini-loader>
      </ui-mini-loader>
    </div>

    <div
        class="wrapper"
        v-if="hasPOBRInit"
    >
      <soglasje-sdd-eracun
          v-if="templateId = 1"
          :form="form"
          :client="client"
          :isAuthITriglav="authData.iTriglav"
      >
      </soglasje-sdd-eracun>

    </div>
  </div>
</template>

<script>

import CommonMixin from "@/mixins/common.mixin";
import POBRAuthMixin from "@/mixins/POBR-Auth.mixin";
import POBRMixin from "@/mixins/POBR.mixin";
import {SoglasjeSDDERacunForm} from "@/classes/forms-by-template/SoglasjeSDDERacunForm";
import SoglasjeSDDERacun from "@/components/forms/SoglasjeSDDERacun";
import UIMiniLoader from "@/components/ui/UIMiniLoader";

export default {
  name: "POBR",
  mixins: [
    CommonMixin,
    POBRAuthMixin,
    POBRMixin
  ],

  data() {
    return {
      hasPOBRInit: false,
      templateId: undefined,
      client: undefined,
      form: undefined,

      formsByTemplate: {
        '1': SoglasjeSDDERacunForm
      },

      keydownEL: undefined
    }
  },

  mounted() {
    this.keydownEL = this.onKeydown.bind(this);
    document.addEventListener('keydown', this.keydownEL);
  },

  destroyed() {
    document.removeEventListener('keydown', this.keydownEL);
  },

  methods: {
    async initPOBR() {
      this.templateId = await this.fetchPOBRTemplateId();

      if (this.templateId) {
        this.client = await this.fetchPOBRClient();

        if (this.client) {
          const formClass = this.formsByTemplate[this.templateId.toString()];
          this.form = new formClass();

          this.hasPOBRInit = true;
        } else {
          this.navigateToNotFound();
        }
      } else {
        this.navigateToNotFound();
      }
    },
  },

  components: {
    'soglasje-sdd-eracun': SoglasjeSDDERacun,
    'ui-mini-loader': UIMiniLoader
  }

}
</script>

<style scoped lang="scss">
</style>
